var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    var panel = this.nextElementSibling;

    if (panel.style.maxHeight) {
      // L'accordion è già aperto → chiudi
      panel.style.maxHeight = null;
      this.classList.remove("active"); // rimuovi la classe anche qui!
    } else {
      // Chiudi gli altri accordion attivi
      let active = document.querySelectorAll(".accordion-div .accordion.active");
      for (let j = 0; j < active.length; j++) {
        active[j].classList.remove("active");
        active[j].nextElementSibling.style.maxHeight = null;
      }

      // Apri questo
      this.classList.add("active");
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}
